import {prependRoot} from "../util/prependRoot.js";
import {getApiRoot} from "../store/configureStore.js";
import axios from "axios";

const routePrefix = "/mijndossier/";

const MijnDossierApi = {
	get(dossierId) {
		const dossierIdForApi = dossierId ? dossierId : "00000000-0000-0000-0000-000000000000";
		const serviceUrl = prependRoot(routePrefix + dossierIdForApi, getApiRoot());
		let returnValue = axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
		return returnValue;
	},
	getSchaduwDossier(dossierId) {
		const dossierIdForApi = dossierId ? dossierId : "00000000-0000-0000-0000-000000000000";
		const serviceUrl = prependRoot(routePrefix + "getSchaduwdossier/" + dossierIdForApi, getApiRoot());
		let returnValue = axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
		return returnValue;
	}
};

export default MijnDossierApi;
